export default "//cdn.scentbird.com/assets/frontbird-site/images/milk-shake_efbceb.jpg";